import React, { useContext, useEffect } from 'react';
import { Users, MessageSquare, AlertCircle, Plus } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import AppContext from '../../context/AppContext';

const GroupList = () => {
  const { channels, id } = useContext(AppContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log("GroupList rendu avec channels:", channels);
  }, [channels]);


  // Déboguer la structure des données channels
  useEffect(() => {
    if (channels) {
      console.log("Structure complète channels:", JSON.stringify(channels, null, 2));
    }
  }, [channels]);
  
  // Transformer les channels en format attendu par le composant
  const items = Object.entries(channels || {}).map(([key, channel]) => {
    console.log("Traitement de channel:", key, channel);
    return {
      id: key,
      name: channel.nom || "Sans nom",
      type: (channel.type || "groupe").toLowerCase(),
      members: 0, // Puisque nous n'avons pas cette information dans les données
      isAvailable: true, // Par défaut tous les canaux sont disponibles
      idGroup: channel.idGroup || "inconnu"
    };
  });
  console.log("groupe id est ",channels)

  const hasAvailableItems = items.length > 0;

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-blue-50">
      <main className="p-6">
        <div className="bg-white rounded-3xl p-6 shadow-sm">
          {hasAvailableItems ? (
            <>
              <h2 className="text-2xl font-bold mb-6">Vos groupes et canaux </h2>
              <div className="space-y-4">
                {items.map(item => (
                  <div 
                  onClick={()=>{

                   // navigate("/GroupeDetail")
                   // navigate("/GroupeDetail", { state: {idGroup:item.idGroup, nom: item.nom ,type:item.type} });
                    navigate(`/GroupeDetail/${item.idGroup}/${item.type}/${item.name}`);
                  }}
                    key={item.id}
                    className="relative rounded-xl p-4 bg-gray-50 hover:bg-gray-100 transition-all"
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-4">
                        <div className={`p-2 rounded-lg ${
                          item.type === 'canal' 
                            ? 'bg-blue-100 text-blue-600' 
                            : 'bg-purple-100 text-purple-600'
                        }`}>
                          {item.type === 'canal' 
                            ? <MessageSquare className="w-5 h-5" />
                            : <Users className="w-5 h-5" />
                          }
                        </div>
                        <div>
                          <h3 className="font-medium">{item.name}</h3>
                          <p className="text-sm text-gray-500">
                            ID: {item.idGroup}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="text-center py-12">
              <div className="bg-gray-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-gray-400" />
              </div>
              <h2 className="text-xl font-medium mb-2">
                Aucun groupe ou canal disponible
              </h2>
              <p className="text-gray-500 mb-8">
                Commencez par ajouter un groupe ou un canal pour utiliser Kappela Vendeur
              </p>
            </div>
          )}

          <div className="mt-8">
            <button 
              onClick={() => {
                navigate('/relierbot');
              }}
              className="w-full bg-blue-600 text-white py-4 rounded-xl flex items-center justify-center space-x-2 hover:bg-blue-700 transition-colors"
            >
              <Plus className="w-5 h-5" />
              <span>Ajouter un groupe ou canal</span>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default GroupList;